import type { ColDef } from 'ag-grid-enterprise'

import { formatAccruedAmount } from '../amount-format'
import type { ChartDataRow } from '../chart-data'
import { compareDecimalAmounts } from '../decimal-sort'

export const chartDataColumns: ColDef<ChartDataRow>[] = [
  { field: 'value_date', headerName: 'Date', minWidth: 125 },
  { field: 'record_type', headerName: 'Type', minWidth: 120 },
  {
    field: 'accrued_balance_local',
    headerName: 'Closing Accrued Local',
    minWidth: 200,
    comparator: compareDecimalAmounts,
    valueFormatter: ({ value }) => formatAccruedAmount(value),
    useValueFormatterForExport: false,
  },
  { field: 'currency', headerName: 'Currency', minWidth: 110 },
  { field: 'trade_id', headerName: 'Trade', minWidth: 180 },
  { field: 'trade_datetime_utc', headerName: 'Executed At (UTC)', minWidth: 220 },
  {
    field: 'quantity',
    headerName: 'Trade Quantity',
    minWidth: 160,
    comparator: compareDecimalAmounts,
    valueFormatter: ({ value }) => formatAccruedAmount(value),
    useValueFormatterForExport: false,
  },
]
